import { MenuOutlined } from "@ant-design/icons";
import { Col, Drawer, Image, Menu, Row, Tabs } from "antd";
import SubMenu from "antd/es/menu/SubMenu";
import { useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../../assets/images/header/nucleusteq_logo.webp";
import nav_arrow from "../../../assets/images/header/nav_arrow.webp";
import { createMainMenu, createSubMenu, activeMenu } from "./headerData";
const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedDrawer, setSelectedDrawer] = useState<any>(null);
  const [tabPosition, setTabPosition] = useState<boolean>(
    window.innerWidth < 1000 ? true : false
  );
  // function useIsMobile(threshold = 1000) {
  //   const [isMobile, setIsMobile] = useState(window.innerWidth < threshold);

  //   useEffect(() => {
  //     const handleResize = () => {
  //       setIsMobile(window.innerWidth < threshold);
  //     };

  //     window.addEventListener("resize", handleResize);
  //     return () => window.removeEventListener("resize", handleResize);
  //   }, [threshold]);

  //   return isMobile;
  // }

  useEffect(() => {
    const handleResize = () => {
      setTabPosition(window.innerWidth < 1000 ? true : false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const mainMenu: any = createMainMenu(
    setSelectedDrawer,
    setDrawerOpen,
    navigate
  );
  const subMenu: any = createSubMenu(setDrawerOpen, navigate);

  const drawerViewMobile = useMemo<any>(() => {
    const menuData = subMenu[selectedDrawer];
    return (
      <>
        <Menu
          mode="inline"
          theme="dark"
          style={{ height: "90vh", width: "100%", overflow: "scroll" }}
          className="mobile-menu"
        >
          {mainMenu.map((menu: any, mainIndex: number) => {
            const menuData = subMenu[menu?.key];
            return menuData ? (
              <SubMenu key={"mainIndex" + mainIndex} title={menu?.name}>
                {menuData?.map((menuTitle: any, childIndex: number) => {
                  return (
                    <>
                      <SubMenu
                        key={
                          "childIndex" + childIndex + "mainIndex" + mainIndex
                        }
                        title={menuTitle?.title?.text}
                      >
                        {menuTitle?.headings?.map(
                          (heading: any, childrenIndex: number) => {
                            return (
                              <Menu.Item
                                key={
                                  "childrenIndex" +
                                  childrenIndex +
                                  "childIndex" +
                                  childIndex +
                                  "mainIndex" +
                                  mainIndex
                                }
                                style={{ height: "100%" }}
                              >
                                <>
                                  <p
                                    style={{
                                      margin: "8px 0",
                                      lineHeight: "normal",
                                    }}
                                    onClick={() => {
                                      setDrawerOpen(false);
                                      heading?.action && heading?.action();
                                    }}
                                  >
                                    <strong>{heading?.text}</strong>{" "}
                                    <img
                                      style={{ scale: ".6" }}
                                      src={nav_arrow}
                                    />
                                  </p>
                                  {heading?.subHeadings?.map(
                                    (subHeading: any) => (
                                      <p
                                        style={{
                                          margin: "8px 0",
                                          lineHeight: "normal",
                                        }}
                                        onClick={() => {
                                          setDrawerOpen(false);
                                          subHeading?.action &&
                                            subHeading?.action();
                                        }}
                                      >
                                        <i>{subHeading?.text}</i>
                                      </p>
                                    )
                                  )}
                                </>
                              </Menu.Item>
                            );
                          }
                        )}
                      </SubMenu>
                    </>
                  );
                })}
              </SubMenu>
            ) : (
              <Menu.Item
                key={"mainIndex" + mainIndex}
                onClick={() => {
                  setDrawerOpen(false);
                  menu?.action && menu?.action();
                }}
                style={menu?.hide ? { visibility: "hidden" } : {}}
              >
                {menu?.name}
              </Menu.Item>
            );
          })}
        </Menu>
      </>
    );
  }, [selectedDrawer]);

  const drawerViewDesktop = useMemo<any>(() => {
    const menuData = subMenu[selectedDrawer] ? subMenu[selectedDrawer] : [];

    return (
      <Row style={{ width: "100%" }}>
        <Col span={24}>
          <Tabs
            style={{ width: "100%" }}
            tabPosition="left"
            className="header-custom-tabs"
            items={menuData.map((menuTitle: any, i: number) => ({
              label: menuTitle?.title?.text,
              key: "item" + i,
              children: (
                <>
                  <div className="headerDrawerData headerDrawerDataDesktop">
                    <h4>{menuTitle?.title?.text}</h4>
                    <Row gutter={[32, 24]} style={{ width: "100%" }}>
                      {menuTitle?.headings?.map((heading: any) => {
                        return (
                          <Col span={8}>
                            <>
                              <h6
                                onClick={() => {
                                  heading?.action && heading.action();
                                }}
                              >
                                {heading?.text}&nbsp;
                                <img style={{ scale: ".8" }} src={nav_arrow} />
                              </h6>
                              {heading?.subHeadings?.map((subHeading: any) => (
                                <h6
                                  key={subHeading.text}
                                  onClick={() => {
                                    subHeading?.action && subHeading.action();
                                  }}
                                >
                                  <span>{subHeading?.text}</span> <br />
                                </h6>
                              ))}
                            </>
                          </Col>
                        );
                      })}
                    </Row>
                  </div>
                </>
              ),
            }))}
          />
        </Col>
      </Row>
    );
    return selectedDrawer;
  }, [selectedDrawer]);

  const hoverTimeout = useRef<any>(null);
  const handleHoverStart = (e: any) => {
    hoverTimeout.current = setTimeout(() => {
      if (
        ["products", "industries", "services", "overview", "careers"].includes(
          e?.key
        )
      ) {
        setSelectedDrawer(e?.key);
        setDrawerOpen(true);
      } else {
        setDrawerOpen(false);
      }
    }, 200);
  };

  const handleHoverEnd = () => {
    clearTimeout(hoverTimeout.current);
  };

  useEffect(() => {
    console.log(location.pathname);
  }, [location]);

  return (
    <>
      <div
        className="menuDiv"
        style={{ position: "sticky", top: 0, width: "100%", zIndex: "1002" }}
      >
        <Row className="infoRow">
          <Col xs={10} sm={10} md={6} lg={6} xl={4} xxl={4}>
            <div className="infoColImage">
              <Link to="/">
                <Image
                  preview={false}
                  src={Logo}
                  loading="lazy"
                  className="headerLogo"
                />
              </Link>
            </div>
          </Col>
          <Col xs={14} sm={14} md={18} lg={18} xl={20} xxl={20}>
            <div>
              {tabPosition ? (
                <div
                  style={{ float: "right" }}
                  onClick={() => setDrawerOpen(true)}
                >
                  <MenuOutlined
                    className="headerMenu"
                    style={{ marginRight: "1rem" }}
                  />
                </div>
              ) : (
                <Menu
                  mode="horizontal"
                  overflowedIndicator={<MenuOutlined className="headerMenu" />}
                  className="menuColStyle"
                  selectedKeys={[
                    selectedDrawer,
                    ...activeMenu(location.pathname),
                  ]}
                  // overflowedIndicator={<MoreOutlined />}
                >
                  {mainMenu.map((menu: any, index: number) => {
                    return (
                      <SubMenu
                        className="menuColStyle1"
                        onTitleMouseEnter={handleHoverStart}
                        onTitleMouseLeave={handleHoverEnd}
                        key={menu?.key}
                        title={
                          <span
                            style={{ textDecoration: "none", color: "#fff" }}
                          >
                            {menu?.name}
                          </span>
                        }
                        style={menu?.hide ? { visibility: "hidden" } : {}}
                        onTitleClick={menu?.action ? menu.action : null}
                      />
                    );
                  })}
                </Menu>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <Drawer
        title="Basic Drawer"
        placement={tabPosition ? "left" : "top"}
        closable={true}
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        key={"placement"}
        style={{
          marginTop: "10vh",
          backgroundColor: "rgba(103, 119, 160, 0.3)",
          backdropFilter: "blur(5px)",
        }}
        styles={{ header: { display: "none" } }}
        height={"90vh"}
        className="headerDrawer"
      >
        <div
          className={`drawerMenuData ${tabPosition && "drawerMenuDataMobile"}`}
          onMouseLeave={() => setDrawerOpen(false)}
        >
          <Row gutter={[16, 16]}>
            {tabPosition ? drawerViewMobile : drawerViewDesktop}
          </Row>
        </div>
      </Drawer>
    </>
  );
};

export default Header;
